import { render, staticRenderFns } from "./PrivacyProtocol.vue?vue&type=template&id=61b19a0f&scoped=true&"
import script from "./PrivacyProtocol.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyProtocol.vue?vue&type=style&index=0&id=61b19a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b19a0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b19a0f')) {
      api.createRecord('61b19a0f', component.options)
    } else {
      api.reload('61b19a0f', component.options)
    }
    module.hot.accept("./PrivacyProtocol.vue?vue&type=template&id=61b19a0f&scoped=true&", function () {
      api.rerender('61b19a0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/BaseInfoChildren/PrivacyProtocol.vue"
export default component.exports